<template>
  <div>
    <TMObstacles />
    <StepsInTM />
    <ActionSteps />
    <TMResources />
    <StartReceive />
  </div>
</template>

<script>
import TMObstacles from "@/components/howItWorks/TMObstacles";
import StepsInTM from "@/components/howItWorks/StepsInTM";
import ActionSteps from "@/components/howItWorks/ActionSteps";
import TMResources from "@/components/howItWorks/TMResources";
import StartReceive from "@/components/howItWorks/StartReceive";

export default {
  name: "HowItWorks",
  components: {
    TMObstacles,
    StepsInTM,
    ActionSteps,
    TMResources,
    StartReceive,
  },
};
</script>